import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { getFunctionResource, getTemplateDataSources } from './request';
import CodeMirror from 'codemirror/lib/codemirror.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/anyword-hint.js';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/search/search.js';
import 'codemirror/addon/search/searchcursor.js';
// 括号匹配
import 'codemirror/addon/edit/matchbrackets.js';
import { clickCopy } from '@/utils/public';
export default {
  data() {
    return {
      functionResource: [],
      selectFunctionItem: {},
      selecedIndex: 0,
      tableConfigList: [],
      editorValue: '',
      markHistory: {},
      // str: 'sum(add(a,b),bao)',
      str: 'TODAY(a,b,SUM)()',
      functionsData: {},
      charInfo: [],
      passValiadte: true,
      associateDataSource: 'system',
      systemDataSource: [],
      dynamicDataSource: [],
      hasStyleError: false,
      hasRestError: false,
      configProp: {
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      cascaderValue: '',
      keyLabelMap: {}
    };
  },
  created() {
    if (this.$route.params.type === 'table') {
      this.tableConfigList = JSON.parse(sessionStorage.getItem('quickConfigList'));
    }
    getFunctionResource({}).then(res => {
      if (res) {
        this.functionResource = res;
        let defaultSelect = sessionStorage.getItem('defaultSelect');
        if (defaultSelect) {
          let defaultSelectFunc = res.filter(item => item.mark === defaultSelect);
          if (defaultSelectFunc.length > 0) {
            this.toggerSelect(defaultSelectFunc[0]);
          }
        }
      }
    });
    this.getAssociateDataSource();
  },
  mounted() {
    this.initCodeMirror();
  },
  watch: {
    editorValue(newValue) {
      if (newValue) {
        if (this.$route.params.type === 'table') {
          let markArr = {};
          this.tableConfigList && Array.isArray(this.tableConfigList) && this.tableConfigList.forEach(item => {
            let indexStart = newValue.indexOf(item.label);
            if (indexStart !== -1) {
              var cursor = this.editor.getSearchCursor(item.label);
              while (cursor.findNext()) {
                markArr[item.label] = [{
                  line: cursor.pos.from.line,
                  ch: cursor.pos.from.ch
                }, {
                  line: cursor.pos.to.line,
                  ch: cursor.pos.to.ch
                }, {
                  css: 'background:#D673D6;color:#fff',
                  clearOnEnter: false
                }];
              }
            }
          });
          let keys = Object.keys(markArr);
          for (let i = 0; i < keys.length; i++) {
            this.editor.markText(...markArr[keys[i]]);
          }
        } else {
          this.cascaderValue.forEach((item, index) => {
            if (newValue.indexOf(item) === -1) {
              this.cascaderValue.splice(index, 1);
            }
          });
        }
      }
    }
  },
  methods: {
    cascaderChange(value) {
      // this.cascaderValue.for;
      let labelArr = [];
      this.cascaderValue.forEach(item => {
        if (this.keyLabelMap[item]) {
          labelArr.push(this.keyLabelMap[item]);
        }
      });
      labelArr.forEach(item => {
        if (this.editorValue.indexOf(item) === -1) {
          this.addRest({
            label: item
          });
        }
      });
    },
    getAssociateDataSource() {
      //设置每一列的关联数据源 以及关联函数下拉数据
      const requestArr = [getTemplateDataSources({
        type: 'system'
      }), getTemplateDataSources({
        type: 'dynamic'
      })];
      Promise.all(requestArr).then(res => {
        if (res.length > 0) {
          const loop = (data, keyValue = '') => {
            return data.map(item => {
              if (item.children) {
                let key = item.mark || item.id;
                item.children = loop(item.children, keyValue ? keyValue + ',' + key : key);
                return {
                  value: item.mark || item.id + '',
                  label: item.name,
                  name: item.name,
                  id: item.id,
                  disabled: true,
                  children: item.children
                };
              } else {
                keyValue = keyValue + ',' + item.mark;
                this.keyLabelMap[item.mark] = item.name;
                //末级字段自定义展示
                return {
                  value: item.mark,
                  name: item.name,
                  id: item.id,
                  label: item.name
                  // label: (
                  //   <span value={item.name} class="isleaf">
                  //     {item.name + '33'}
                  //     {/* <svg-icon
                  //       icon="copy"
                  //       size="20"
                  //       class="copy-icon"
                  //       nativeOnClick={e => this.copyFunction(e, item)}
                  //     /> */}
                  //   </span>
                  // )
                };
              }
            });
          };
          // let formatSystemData = loop(res[0]);
          // let formatDynamic = loop(res[1]);
          this.systemDataSource = loop(res[0]);
          this.dynamicDataSource = loop(res[1]);
        }
      });
    },
    addRest(item) {
      let cursorInfo = this.editor.getCursor();
      let pos = {
        line: cursorInfo.line,
        //行号
        ch: cursorInfo.ch //光标位置
      };
      this.editor.replaceRange(item.label, pos); //替换内容
      this.editor && this.editor.focus();
      this.editor.setCursor({
        line: cursorInfo.line,
        ch: cursorInfo.ch + item.label.length
      });
    },
    toggerSelect(item, index) {
      this.selectFunctionItem = item;
      let cursorInfo = this.editor.getCursor();
      let pos = {
        line: cursorInfo.line,
        //行号
        ch: cursorInfo.ch //光标位置
      };
      this.editor.replaceRange(item.mark + '()', pos); //替换内容
      this.editor && this.editor.focus();
      this.editor.setCursor({
        line: pos.line,
        ch: pos.ch + item.mark.length + '()'.length
      });
    },
    findfirstLevel(str, start, end) {
      //获取第一层括号的位置信息
      // let start = 0;
      // let end = str.length - 1;
      let teplateArr = [];
      let charArr = str.split('');
      while (start < end) {
        if (charArr[start] !== '(') {
          start++;
        }
        if (charArr[end] !== ')') {
          end--;
        }
        if (charArr[start] === '(' && charArr[end] === ')') {
          let obj = {
            start: start + 1,
            end: end - 1
          };
          teplateArr.push(obj);
          break;
        }
      }
      return teplateArr;
    },
    copyFunction() {
      if (this.editorValue.length > 0) {
        this.passValiadte = true;
        this.hasRestError = false;
        this.hasStyleError = false;
        this.functionsData = this.copyVerification(this.editorValue, 0, this.editorValue.length - 1);
      } else {
        this.$message.error(this.$t('请输入内容'));
        return;
      }
      if (this.passValiadte) {
        //校验通过后，生成复制值
        this.generateCopyValue();
      } else {
        if (this.hasStyleError) {
          this.$message.error(this.$t('格式有误，请检查后重新填写'));
          return;
        }
        if (this.hasRestError) {
          this.$message.error(this.$t('参数个数不匹配'));
          return;
        }
      }
    },
    generateCopyValue() {
      //生成复制的值
      if (this.functionsData.type === 'function') {
        //最外层是函数
        const loop = data => {
          let rest = '';
          data.forEach((item, index) => {
            if (item.type === 'function') {
              if (item.children) {
                rest = rest + item.mark + '(' + loop(item.children) + ')';
              } else {
                rest = index === data.length - 1 ? rest + item.mark + '()' : rest + item.mark + '(),';
              }
            } else {
              if (!item.text) {
                rest += '';
              } else {
                if (this.$route.params.type === 'table') {
                  let idKey = this.tableConfigList.filter(tableItem => {
                    return tableItem.label === item.text;
                  });
                  let mark = '';
                  if (idKey.length) {
                    mark = idKey[0].mark.slice(2);
                    mark = mark.slice(idKey[0].mark, mark.length - 2);
                  }
                  let textResult = idKey.length ? mark : item.text;
                  rest += index === data.length - 1 ? textResult : textResult + ',';
                }
              }
            }
          });
          return rest;
        };
        let childrenText = this.functionsData.children && this.functionsData.children.length > 0 ? loop(this.functionsData.children) : '';
        let result = this.functionsData.mark + '(' + childrenText + ')';
        result = '${' + result + '}';
      } else {
        this.$message.error(this.$t('格式有误，请检查后重新填写'));
        this.setErrorCursor(0);
      }
    },
    copyData(value) {
      clickCopy(value);
    },
    validateFunName(functionName) {
      //校验函数名称是否存在
      let validate = null;
      this.functionResource.forEach(item => {
        if (item.mark === functionName) {
          validate = item;
        }
      });
      return validate;
    },
    setErrorCursor(ch) {
      this.editor && this.editor.focus();
      this.editor.setCursor({
        line: 0,
        ch: ch
      });
    },
    copyVerification(str, start, end) {
      //校验思路  先找到最外层函数，找到参数部分的','，判断出真正的逗号，然后递归参数，判断参数的个数是否相符，递归所有的参数项
      let charArr = str.split('');
      let teplateArr = this.findfirstLevel(str, start, end);
      if (teplateArr.length == 0) {
        if (str.indexOf('(') !== -1 || str.indexOf(')') !== -1) {
          //参数中有(的情况下校验 校验是否是函数
          let validateFunction = this.vali(str);
          if (!validateFunction) {
            this.passValiadte = false;
            this.hasStyleError = true;
            this.setErrorCursor(start);
            return;
          }
        }
        return {
          text: str.slice(start, end + 1),
          type: 'text'
        };
      }
      let firstInfo = teplateArr[0];
      let functionsData = {};
      let functionNum = charArr.slice(start, firstInfo.start - 1).join('');
      //校验函数名称是否存在
      let functionInfo = this.validateFunName(functionNum);
      if (!functionInfo) {
        this.passValiadte = false;
        this.hasStyleError = true;
        // this.$message.error(this.$t('格式有误，请检查后重新填写'));
        this.setErrorCursor(start);
        return;
      } else {
        functionsData = {
          rest: [],
          restText: [],
          mark: functionInfo.mark,
          inputNumber: functionInfo.inputNumber,
          type: 'function'
        };
      }
      //第一层括号内的内容
      let restItem = charArr.slice(firstInfo.start, firstInfo.end + 1);
      let dou = {};
      //获取参数内的逗号的位置
      restItem.forEach((item, index) => {
        if (item === ',') {
          dou[index] = restItem.join('').slice(0, index);
        }
      });
      let innerItem = []; //
      let douKey = Object.keys(dou);
      if (douKey.length === 0 && firstInfo.start - 1 === firstInfo.end) {
        //没有参数的情况
        if (functionInfo.inputNumber !== 0) {
          this.passValiadte = false;
          this.hasRestError = true;
          // this.$message.error(this.$t('参数个数不匹配'));
          this.setErrorCursor(firstInfo.start);
        }
        return functionsData;
      } else if (douKey.length === 0 && firstInfo.start - 1 !== firstInfo.end) {
        //没有逗号，参数长度不为0 说明参数为1
        innerItem.push({
          start: firstInfo.start,
          end: firstInfo.end
        });
      }
      let trDiverIndex = [];
      for (let i = 0; i < Object.keys(dou).length; i++) {
        let item = dou[douKey[i]];
        if (this.vali(item)) {
          //校验该逗号前面是否有完整的(),校验通过则说明该位置的逗号是真正的参数分割，trDiverIndex的长度就是该函数参数的个数
          trDiverIndex.push(douKey[i]);
        }
      }
      trDiverIndex.forEach((ybb, index) => {
        if (index == 0) {
          let obj = {
            start: firstInfo.start,
            end: Number(firstInfo.start) + Number(ybb)
          };
          innerItem.push(obj);
        }
        if (index === trDiverIndex.length - 1) {
          let objj2 = {
            start: Number(firstInfo.start) + Number(ybb) + 1,
            end: firstInfo.end
          };
          innerItem.push(objj2);
        } else {
          let objj3 = {
            start: Number(firstInfo.start) + Number(ybb) + 1,
            end: Number(firstInfo.start) + Number(trDiverIndex[index + 1])
          };
          innerItem.push(objj3);
        }
      });
      //判断参数个数是否相符
      if (innerItem.length !== functionInfo.inputNumber) {
        this.passValiadte = false;
        this.hasRestError = true;
        // this.$message.error(this.$t('参数个数不匹配'));
        this.setErrorCursor(end);
        return;
      }
      if (innerItem.length > 0) {
        functionsData.children = [];
      }
      innerItem.forEach(item => {
        if (functionInfo) {
          functionsData.rest.push(item);
          functionsData.restText.push(str.slice(item.start, item.end + 1));
        }
        let childrenFunctionData = this.copyVerification(str, item.start, item.end);
        functionsData.children.push(childrenFunctionData);
      });
      return functionsData;
    },
    vali(str) {
      let ybb = true;
      let leftReg = /(\()/g;
      let leftBracketNum = str.match(leftReg) && str.match(leftReg).length || 0;
      let rightReg = /(\))/g;
      let rightBracketNum = str.match(rightReg) && str.match(rightReg).length || 0;
      if (leftBracketNum === 0 && rightBracketNum === 0) {
        //说明是个字符串
        return true;
      }
      if (leftBracketNum !== rightBracketNum) {
        // this.$message.error(this.$t('格式有误，请检查后重新填写'));
        ybb = false;
        return false;
      }
      let reg = /.+\(.*\)/g;
      let count = 0;
      let matchResult = str.match(reg);
      count += matchResult.length;
      let loop = data => {
        data.forEach(item => {
          var regex11 = /([^\(]+)\(.*\)/g;
          let matchResult1 = regex11.exec(item)[1];
          let item1 = item.replace(matchResult1, '');
          item1 = item1.replace('(', '');
          item1 = item1.slice(0, item1.length - 1);
          let matchArr = item1.match(reg);
          if (matchArr && matchArr.length) {
            count += matchArr.length;
            loop(matchArr);
          }
        });
      };
      if (matchResult && matchResult.length > 0) {
        loop(matchResult);
      }
      if (leftBracketNum !== count) {
        return false;
      }
      if (leftBracketNum !== count) {
        return false;
      }
      return ybb;
    },
    copy() {
      let str = 'sum(add(),bao)()';
      let leftReg = /(\()/g;
      let leftBracketNum = str.match(leftReg).length;
      let rightReg = /(\))/g;
      let rightBracketNum = str.match(rightReg).length;
      if (leftBracketNum !== rightBracketNum) {
        this.$message.error(this.$t('格式有误，请检查后重新填写'));
      }
      let reg = /.+\(.*\)/g;
      let count = 0;
      let matchResult = str.match(reg);
      count += matchResult.length;
      let loop = data => {
        data.forEach(item => {
          var regex11 = /([^\(]+)\(.*\)/g;
          let matchResult1 = regex11.exec(item)[1];
          let item1 = item.replace(matchResult1, '');
          item1 = item1.replace('(', '');
          item1 = item1.slice(0, item1.length - 1);
          let matchArr = item1.match(reg);
          if (matchArr && matchArr.length) {
            count += matchArr.length;
            loop(matchArr);
          }
        });
      };
      if (matchResult && matchResult.length > 0) {
        loop(matchResult);
      }
      if (rightBracketNum !== count) {
        this.$message.error(this.$t('格式有误，请检查后重新填写'));
      }
      let a = reg.exec(str);
    },
    initCodeMirror() {
      this.$nextTick(() => {
        CodeMirror.commands.autocomplete = function (cm) {
          cm.showHint({
            hint: CodeMirror.hint.anyword
          });
        };
        this.editor = CodeMirror.fromTextArea(this.$refs.codeMirrorBox, {
          editorValue: this.editorValue,
          mode: 'javascript',
          readOnly: this.readOnly,
          lineNumbers: true,
          // autofocus: true, // 光标默认显示
          lineWrapping: true,
          foldGutter: true,
          gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
          matchBrackets: true,
          extraKeys: {
            'Ctrl-F1': 'autocomplete'
          },
          completeSingle: false
        });
        this.editor.on('change', editor => {
          this.editorValue = editor.getValue('\n');
        });
        this.editor.setSize(this.width, this.height);
      });
    }
  }
};